(function () {
  if (window.__lumConsentBridge) return;
  var retailId = window.__lumRetailMeasurementId || '';
  var clinicId = window.__lumClinicMeasurementId || '';
  if (!/^G-[A-Z0-9]+$/.test(retailId) || !window.__lumConsentDefaultsSet || typeof window.gtag !== 'function') return;
  var initialized = false, pageViewed = false, loadingPrivacy = false, lastState = null;
  function processingAllowed() {
    try {
      var p = window.Shopify && window.Shopify.customerPrivacy;
      return !!p && typeof p.analyticsProcessingAllowed === 'function' && p.analyticsProcessingAllowed() === true;
    } catch (e) { return false; }
  }
  function sync() {
    var allowed = processingAllowed();
    window['ga-disable-' + retailId] = !allowed;
    if (/^G-[A-Z0-9]+$/.test(clinicId)) window['ga-disable-' + clinicId] = !allowed;
    if (allowed !== lastState) {
      window.gtag('consent', 'update', {
        analytics_storage: allowed ? 'granted' : 'denied',
        ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied'
      });
      lastState = allowed;
    }
    if (!allowed) return;
    if (!initialized) {
      initialized = true;
      window.gtag('js', new Date());
      window.gtag('config', retailId, {send_page_view: false, allow_google_signals: false, allow_ad_personalization_signals: false});
      // after the page has painted and settled, not in the way of it (29 Oct
      // 2026): gtag() queues into dataLayer meanwhile, so nothing is lost
      var inject = function () {
        var script = document.createElement('script');
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(retailId);
        document.head.appendChild(script);
      };
      var later = function () { if (window.requestIdleCallback) window.requestIdleCallback(inject, {timeout: 2500}); else setTimeout(inject, 1200); };
      if (document.readyState === 'complete') later(); else window.addEventListener('load', later, {once: true});
    }
    if (!pageViewed && window.__lumNativeRetailGa4 !== true) {
      pageViewed = true;
      window.gtag('event', 'page_view', {send_to: retailId});
    }
    document.dispatchEvent(new CustomEvent('luminate:analytics-ready'));
  }
  function ready() {
    sync();
    var shopify = window.Shopify;
    if (!loadingPrivacy && shopify && !shopify.customerPrivacy && typeof shopify.loadFeatures === 'function') {
      loadingPrivacy = true;
      try {
        shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) {
          loadingPrivacy = false;
          if (!error) sync();
        });
      } catch (e) { loadingPrivacy = false; }
    }
  }
  window.__lumConsentBridge = {
    allowed: function () { return initialized && lastState === true && processingAllowed(); }
  };
  document.addEventListener('visitorConsentCollected', ready);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once: true});
  ready();
})();
